/*
  Eternal Elegance - Signature Box & Pouch test (theme "_Box Test" only).
  - Any cart with at least one piece gets exactly one free box (variant INCLUDED, $0), added automatically.
  - Extra boxes are the EXTRA variant ($5 each), up to one box per piece (so extras <= pieces - 1).
  - Both box variants carry SKU EM-BG-ETERNAL-1. Their lines are hidden from the cart list; the card in
    snippets/ee-gift-box.liquid is the only place they show.
  - Every cart on this theme gets the hidden attribute _box_test, so every order from the test arm can be found
    (box buyers or not). It shows under "Additional details" on the order, never to the shopper.
  - Watches every cart write (fetch and XHR) so it works with every builder and quick-add on the site, and holds the
    Checkout button for a moment if a box update is still in flight.
*/
(function () {
  'use strict';
  if (window.__eeGiftBox) return;
  window.__eeGiftBox = true;

  var INCLUDED = 45980980904125;
  var EXTRA = 67779424321725;
  var ATTR_KEY = '_box_test';
  var ATTR_VAL = 'B - 1 free box, extras $5';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var rawFetch = window.fetch.bind(window);
  var timer = null;
  var running = null;
  var queued = false;
  var dirty = true;
  var bypass = false;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function getCart() {
    return rawFetch(root() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function post(path, body) {
    return rawFetch(root() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function refresh() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  // What the cart should hold: one free box when it has pieces, extras capped at one box per piece.
  function plan(cart) {
    var pieces = 0, inc = 0, ext = 0;
    (cart.items || []).forEach(function (it) {
      if (it.variant_id === INCLUDED) inc += it.quantity;
      else if (it.variant_id === EXTRA) ext += it.quantity;
      else pieces += it.quantity;
    });
    var wantInc = pieces > 0 ? 1 : 0;
    var wantExt = pieces > 0 ? Math.min(ext, pieces - 1) : 0;
    var updates = {};
    var change = false;
    if (inc !== wantInc) { updates[INCLUDED] = wantInc; change = true; }
    if (ext !== wantExt) { updates[EXTRA] = wantExt; change = true; }
    var body = { updates: updates };
    var needAttr = pieces > 0 && (!cart.attributes || cart.attributes[ATTR_KEY] !== ATTR_VAL);
    if (needAttr) {
      body.attributes = {};
      body.attributes[ATTR_KEY] = ATTR_VAL;
    }
    return { body: body, write: change || needAttr, change: change };
  }

  // Brings the cart in line with the plan. Resolves to true when box lines changed.
  function sync(silent) {
    if (running) { queued = true; return running; }
    dirty = true;
    running = getCart()
      .then(function (cart) {
        var p = plan(cart);
        if (!p.write) return false;
        return post('cart/update.js', p.body).then(function () { return p.change; });
      })
      .catch(function (e) {
        if (window.console) console.warn('[ee-gift-box]', e);
        return false;
      })
      .then(function (changed) {
        running = null;
        if (queued) {
          queued = false;
          return sync(silent).then(function (again) { return changed || again; });
        }
        dirty = false;
        if (changed && !silent) refresh();
        return changed;
      });
    return running;
  }

  function schedule() {
    dirty = true;
    clearTimeout(timer);
    timer = setTimeout(function () { sync(false); }, 120);
  }

  // Watch every cart write made by the theme, the builders and apps.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var req = rawFetch(input, init);
    if (CART_WRITE.test(url)) {
      dirty = true;
      req.then(schedule, schedule);
    }
    return req;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__eeCart = CART_WRITE.test(String(url || ''));
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__eeCart) {
      dirty = true;
      this.addEventListener('loadend', schedule);
    }
    return xhrSend.apply(this, arguments);
  };

  // "Add box" and the - / + stepper on the card.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-ee-gb-set]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.ee-gb');
    if (!card || card.classList.contains('is-busy')) return;
    var n = Math.max(0, parseInt(btn.getAttribute('data-ee-gb-set'), 10) || 0);
    card.classList.add('is-busy');
    dirty = true;
    Promise.resolve(running)
      .then(function () {
        var updates = {};
        updates[EXTRA] = n;
        return post('cart/update.js', { updates: updates });
      })
      .then(function () { return sync(true); })
      .catch(function (err) { if (window.console) console.warn('[ee-gift-box]', err); })
      .then(function () {
        keepCardInView();
        refresh();
        // The card is re-rendered by the refresh; this only matters if the refresh fails.
        setTimeout(function () { card.classList.remove('is-busy'); }, 4000);
      });
  });

  // The drawer re-render resets its scroll to the top. After a tap on the card, put the list back where it was
  // and make sure the whole card (with its "added" confirmation) is on screen.
  function keepCardInView() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer || !drawer.classList.contains('active')) return;
    var oldBody = drawer.querySelector('.ee-cart__body');
    var prev = oldBody ? oldBody.scrollTop : 0;
    var done = false;
    var mo = new MutationObserver(function () {
      if (done) return;
      done = true;
      mo.disconnect();
      var body = drawer.querySelector('.ee-cart__body');
      var card = body && body.querySelector('.ee-gb');
      if (!body || !card) return;
      body.scrollTop = prev;
      var below = card.getBoundingClientRect().bottom - body.getBoundingClientRect().bottom + 12;
      if (below > 0) body.scrollTop += below;
    });
    mo.observe(drawer, { childList: true, subtree: true });
    setTimeout(function () { if (!done) { done = true; mo.disconnect(); } }, 6000);
  }

  // Tap the box photo or its name to see the box and pouch large. The preview sits on <body>, above the drawer.
  var lb = null;
  var lbTrigger = null;

  function buildPreview() {
    lb = document.createElement('div');
    lb.className = 'ee-gb-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Signature Gift Box & Pouch');
    lb.innerHTML =
      '<div class="ee-gb-lb__panel">' +
        '<button type="button" class="ee-gb-lb__x" aria-label="Close"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 3l10 10M13 3 3 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>' +
        '<div class="ee-gb-lb__media"><img class="ee-gb-lb__img" alt="Signature Gift Box with suede-finish pouch" sizes="(max-width: 560px) 100vw, 520px"></div>' +
        '<div class="ee-gb-lb__text"><p class="ee-gb-lb__title"></p><p class="ee-gb-lb__body"></p><p class="ee-gb-lb__note"></p></div>' +
      '</div>';
    document.body.appendChild(lb);
    lb.addEventListener('click', function (e) {
      if (e.target === lb || (e.target.closest && e.target.closest('.ee-gb-lb__x'))) closePreview();
    });
  }

  function openPreview(btn) {
    if (!lb) buildPreview();
    lbTrigger = btn;
    var img = lb.querySelector('.ee-gb-lb__img');
    var srcset = btn.getAttribute('data-srcset') || '';
    if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
    img.src = btn.getAttribute('data-src') || '';
    lb.querySelector('.ee-gb-lb__title').textContent = btn.getAttribute('data-title') || '';
    lb.querySelector('.ee-gb-lb__body').textContent = btn.getAttribute('data-text') || '';
    lb.querySelector('.ee-gb-lb__note').textContent = btn.getAttribute('data-note') || '';
    // Force a reflow so the fade-in runs on the first open too.
    void lb.offsetWidth;
    lb.classList.add('is-open');
    document.documentElement.classList.add('ee-gb-lb-open');
    lb.querySelector('.ee-gb-lb__x').focus();
  }

  function closePreview() {
    if (!lb || !lb.classList.contains('is-open')) return;
    lb.classList.remove('is-open');
    document.documentElement.classList.remove('ee-gb-lb-open');
    if (lbTrigger && document.contains(lbTrigger)) lbTrigger.focus();
    lbTrigger = null;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-ee-gb-zoom]');
    if (!btn) {
      var proxy = e.target.closest('[data-ee-gb-zoom-proxy]');
      var card = proxy && proxy.closest('.ee-gb');
      btn = card && card.querySelector('[data-ee-gb-zoom]');
    }
    if (!btn) return;
    e.preventDefault();
    openPreview(btn);
  });

  // Escape closes the preview only, not the cart drawer behind it (the theme closes panels on keyup).
  function onEscape(e) {
    if (!lb || !lb.classList.contains('is-open')) return;
    if (e.key !== 'Escape' && e.code !== 'Escape') return;
    e.stopImmediatePropagation();
    if (e.type === 'keyup') closePreview();
  }
  window.addEventListener('keydown', onEscape, true);
  window.addEventListener('keyup', onEscape, true);

  // Hold Checkout until the box lines are settled, so every order leaves with the right boxes.
  document.addEventListener('click', function (e) {
    if (bypass) return;
    var btn = e.target && e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn) return;
    if (!dirty && !running) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.classList.add('loading');
    var go = function () {
      btn.classList.remove('loading');
      bypass = true;
      try { btn.click(); } finally { bypass = false; }
    };
    clearTimeout(timer);
    sync(true).then(go, go);
  }, true);

  function start() { sync(false); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(false); });
})();
